export default Object.freeze({
  ADD: 'add',
  REMOVE: 'remove',
  REPLACE: 'replace',
  NONE: 'none',
});
